const DependencyMap = require('./dependency-map');

module.exports = DependencyMap;
